import { type ClickHelperEventType } from './ClickHelperEventType.js';
import { type Listener } from './Notifier.js';

export type ClickHelperEventListener = Listener<ClickHelperEventType>;
